var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._b({class:_vm.cssClass,attrs:{"elevation":"2"}},'v-sheet',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }